import styled, { css } from 'styled-components';
import { Wrapper } from 'AppReact';

const Tr = styled.tr`
  ${({ displayState }) => css`
    height: 60px;
    cursor: pointer;
    border-bottom: 1px solid #E7EBEB;
    white-space: nowrap;

    th {
      background: #FFFFFF;
    }
    opacity: ${displayState?.opacity ?? 1};
  `}
`;

export default Wrapper(Tr);
